import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { videoShape } from '../../utils/shapes';
import './VideoPlayer.css';
import '../VideoEmbed/VideoEmbed.css';
import YouTube from 'react-youtube';
import { loopSound, stopLoopSound } from 'containers/App/actions';
import { BACKGROUND_MUSIC_SOUND } from '../../sounds';

function VideoPlayer({ video, stopBackgroundSounds, startBackgroundSounds }) {
  const date = new Date(video.snippet.publishedAt);

  return (
    <div className="video-player">
      <YouTube
        videoId={video.id.videoId}
        containerClassName="video-embed"
        onPlay={stopBackgroundSounds}
        onPause={startBackgroundSounds}
        onEnd={startBackgroundSounds}
      />
      <h2 className="video-title">{video.snippet.title}</h2>
      <div className="video-info clearfix">
        <div className="video-meta">
          <span className="meta-item video-publish-date">
            Published on {date.toDateString()}
          </span>
        </div>
      </div>
      <div className="video-description">
        <p>{video.snippet.description}</p>
      </div>
    </div>
  );
}

VideoPlayer.propTypes = {
  video: videoShape,
  startBackgroundSounds: PropTypes.func,
  stopBackgroundSounds: PropTypes.func
};

function mapDispatchToProps(dispatch) {
  return {
    startBackgroundSounds: () => {
      dispatch(loopSound(BACKGROUND_MUSIC_SOUND));
    },
    stopBackgroundSounds: () => {
      dispatch(stopLoopSound(BACKGROUND_MUSIC_SOUND));
    }
  };
}

export default connect(null, mapDispatchToProps)(VideoPlayer);



// WEBPACK FOOTER //
// ./src/components/VideoPlayer/index.js